import { Stack, styled } from "@mui/material";

export const StyledSettingsScreen = styled(Stack)(() => ({
  borderRadius: "8px",
  padding: "20px",
  boxShadow: "0px 2px 6px 0px #4C4E641A",
  background: "white",
  justifyContent: "space-between",
  height: "100%",
}));
